import { createContext, useContext, useState, useEffect, useCallback } from "react";

const KEY = "toolnest:favorites";
const FavoritesContext = createContext(null);

export function FavoritesProvider({ children }) {
  const [favorites, setFavorites] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setFavorites(JSON.parse(raw));
    } catch (e) {
      /* ignore */
    }
  }, []);

  const persist = useCallback((next) => {
    setFavorites(next);
    try {
      localStorage.setItem(KEY, JSON.stringify(next));
    } catch (e) {
      /* ignore */
    }
  }, []);

  const toggleFavorite = useCallback(
    (slug) => {
      persist(
        favorites.includes(slug)
          ? favorites.filter((s) => s !== slug)
          : [...favorites, slug]
      );
    },
    [favorites, persist]
  );

  const isFavorite = useCallback((slug) => favorites.includes(slug), [favorites]);

  return (
    <FavoritesContext.Provider value={{ favorites, toggleFavorite, isFavorite }}>
      {children}
    </FavoritesContext.Provider>
  );
}

export function useFavorites() {
  const ctx = useContext(FavoritesContext);
  if (!ctx) throw new Error("useFavorites must be used within FavoritesProvider");
  return ctx;
}
